import { createContext, useContext } from 'react';

import { RenderModeEnum } from '../../../../utils/widgets';

type WidgetContextType = {
	renderMode: RenderModeEnum;
};

export const WidgetSimulatorsContext = createContext<WidgetContextType | undefined>(undefined);

export const useWidgetSimulatorsContext = () => {
	const context = useContext(WidgetSimulatorsContext);

	if (context === undefined) {
		throw new Error('WidgetSimulatorsContext should be used within WidgetSimulators');
	}

	return context;
};
